import { render } from "./income.vue?vue&type=template&id=20bd82bd&scoped=true"
import script from "./income.vue?vue&type=script&lang=js"
export * from "./income.vue?vue&type=script&lang=js"

import "./income.vue?vue&type=style&index=0&id=20bd82bd&scoped=true&lang=css"
import "./income.vue?vue&type=style&index=1&id=20bd82bd&lang=css"

import exportComponent from "C:\\src\\web\\finance\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bd82bd"]])

export default __exports__